import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, UTKAL_IMAGE } from "./shared";

export const AboutSection = React.forwardRef(function AboutSection(_, ref) {
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const contentOpacity = useTransform(scrollYProgress, [0, 0.55, 1], [1, 1, 0]);
  const contentY = useTransform(scrollYProgress, [0, 1], [0, -60]);

  return (
    <section
      id="about"
      ref={ref}
      className="relative w-full min-h-screen overflow-hidden snap-start flex items-center"
      data-testid="utkal-section"
    >
      {/* Background image with editorial darken */}
      <div className="absolute inset-0" aria-hidden="true">
        <img
          src={UTKAL_IMAGE}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
          style={{ objectPosition: "center 55%" }}
          loading="lazy"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(20,30,22,0.55) 0%, rgba(20,30,22,0.62) 50%, rgba(20,30,22,0.55) 100%)",
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse at center, rgba(0,0,0,0.18) 0%, rgba(0,0,0,0) 65%)",
          }}
        />
      </div>

      <motion.div
        className="relative w-full max-w-2xl mx-auto text-center px-6 md:px-12 py-20 md:py-24"
        style={{ opacity: contentOpacity, y: contentY }}
      >
        <Reveal
          as="div"
          className="text-[11px] tracking-[0.28em] uppercase text-white/75 mb-10 md:mb-14 font-sans font-semibold"
        >
          About the project
        </Reveal>
        <Reveal
          as="h2"
          delay={0.05}
          className="font-serif text-3xl md:text-4xl lg:text-5xl leading-[1.15] tracking-[-0.01em] font-light text-white"
          style={{ textShadow: "0 2px 24px rgba(0,0,0,0.45)" }}
          data-testid="utkal-heading"
        >
          The Utkal Bharat
          <br />
          Biochar Project
        </Reveal>
        <Reveal
          as="p"
          delay={0.15}
          className="mt-10 md:mt-14 text-white/90 text-lg md:text-xl leading-[1.75] font-sans font-light max-w-xl mx-auto"
          style={{ textShadow: "0 1px 16px rgba(0,0,0,0.45)" }}
          data-testid="utkal-body"
        >
          Utkal is the ancient name for Odisha — a land long known for
          excellence in art and skilled craft. This project reframes biochar
          production as exactly that: an age-old, skillful craft, practised
          with care and scaled responsibly across India.
        </Reveal>

        <Reveal
          as="div"
          delay={0.25}
          duration={0.95}
          y={20}
          className="mt-10 md:mt-12"
        >
          <a
            href="https://registry.rainbowstandard.io/projects/RIV-2026-PROJ-166?mechanism=REMOVAL"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="rainbow-registry-link"
            className="group inline-flex items-center gap-3 text-[11px] md:text-xs tracking-[0.22em] uppercase text-white/85 hover:text-white font-sans font-semibold transition-colors duration-300"
          >
            Listed on Rainbow Registry
            <span
              aria-hidden="true"
              className="text-sm leading-none transition-transform duration-300 group-hover:translate-x-1"
            >
              →
            </span>
          </a>
        </Reveal>
      </motion.div>
    </section>
  );
});
